function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import AccesoServicios from 'src/_panel/module/uni-base/services/AccesoServicios';
import { RestClient } from '../../data/rest-client';
import { IApiRestFormulariosClient, IApiRestCurriculumsClient, IApiRestGestionCurriculumsClient, IApiRestLoginClient, IApiRestMainQuestionsClient, IApiRestGestionMenuClient, IApiRestDatosClient, IApiRestHistoricoCurriculumsClient, IApiRestGestionTextosClient, IApiRestDocumentacionClient, IApiRestGestionFormsInternosClient, IApiRestMenuPublicosClient, IApiRestFormulariosPublicosClient, IApiRestHistoricoFormsInternosClient } from 'src/model/candidato-api';
import { IApiRestMenuClient, IApiRestEdicionFormulariosClient, IApiRestEdicionPreguntasClient } from '../../../model/candidato-api';
function _detectaPath(def) {
  var _process, _process2;
  console.log('---> detectapath', window.location, (_process = process) === null || _process === void 0 ? void 0 : _process.env);
  if ((_process2 = process) !== null && _process2 !== void 0 && _process2.browser) {
    if (window.location.href.match('http://localhost:5001')) {
      return '/pmc';
    }
    if (window.location.href.match('http://localhost:5000') || window.location.href.match(/192\.168.*5000/)) {
      return '/curr';
    }
    if (window.__api) {
      return window.__api;
    }
  }
  return def;
}
var BASE_CANDIDATO = _detectaPath('/pmc');
export var BASE_CANDIDATO_API = "".concat(BASE_CANDIDATO, "/");
var BASE_URL_REST_DATA_API = "".concat(BASE_CANDIDATO, "/_api");
export var AccesoDatos = /*#__PURE__*/function () {
  AccesoDatos.$inject = ["$log", "NotifService", "AccesoServicios"];
  function AccesoDatos(
  //
  $log, NotifService, AccesoServicios) {
    _classCallCheck(this, AccesoDatos);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoServicios = AccesoServicios;
  }
  return _createClass(AccesoDatos, [{
    key: "_urlRestDataApi",
    value: function _urlRestDataApi(apipath) {
      return "".concat(BASE_URL_REST_DATA_API, "/").concat(apipath);
    }
  }, {
    key: "_simple_resource",
    value: function _simple_resource(resource, idprop) {
      return new RestClient(this.AccesoServicios, this._urlRestDataApi(resource), resource, idprop);
    }
  }, {
    key: "menuResource",
    get: function get() {
      if (!this._menu_resource) this._menu_resource = this._simple_resource('modelMenus', function (e) {
        return e.idmen;
      });
      return this._menu_resource;
    }
  }, {
    key: "formularResource",
    get: function get() {
      if (!this._formular_resource) this._formular_resource = this._simple_resource('modelFormularios', function (e) {
        return e.idform;
      });
      return this._formular_resource;
    }
  }, {
    key: "EdicionFormular_CLIENT",
    get: function get() {
      if (!this._edicionformularios_CLIENT) this._edicionformularios_CLIENT = new IApiRestEdicionFormulariosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._edicionformularios_CLIENT;
    }
  }, {
    key: "Formular_CLIENT",
    get: function get() {
      if (!this._formularios_CLIENT) this._formularios_CLIENT = new IApiRestFormulariosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._formularios_CLIENT;
    }
  }, {
    key: "FormularPublicos_CLIENT",
    get: function get() {
      if (!this._formulariosPublicios_CLIENT) this._formulariosPublicios_CLIENT = new IApiRestFormulariosPublicosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._formulariosPublicios_CLIENT;
    }
  }, {
    key: "Menu_CLIENT",
    get: function get() {
      if (!this._menus_CLIENT) this._menus_CLIENT = new IApiRestMenuClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._menus_CLIENT;
    }
  }, {
    key: "MenuPublicos_CLIENT",
    get: function get() {
      if (!this._menusPublicos_CLIENT) this._menusPublicos_CLIENT = new IApiRestMenuPublicosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._menusPublicos_CLIENT;
    }
  }, {
    key: "Preg_CLIENT",
    get: function get() {
      if (!this._pregs_CLIENT) this._pregs_CLIENT = new IApiRestEdicionPreguntasClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._pregs_CLIENT;
    }
  }, {
    key: "MainQuestions_CLIENT",
    get: function get() {
      if (!this._mainQuestions_CLIENT) this._mainQuestions_CLIENT = new IApiRestMainQuestionsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._mainQuestions_CLIENT;
    }
  }, {
    key: "Curr_CLIENT",
    get: function get() {
      if (!this._curr_CLIENT) this._curr_CLIENT = new IApiRestCurriculumsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._curr_CLIENT;
    }
  }, {
    key: "GestionCurr_CLIENT",
    get: function get() {
      if (!this._gestioncurr_CLIENT) this._gestioncurr_CLIENT = new IApiRestGestionCurriculumsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._gestioncurr_CLIENT;
    }
  }, {
    key: "GestionSolicitudes_CLIENT",
    get: function get() {
      if (!this._gestionsolicitudes_CLIENT) this._gestionsolicitudes_CLIENT = new IApiRestGestionFormsInternosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._gestionsolicitudes_CLIENT;
    }
  }, {
    key: "HistoricCurr_CLIENT",
    get: function get() {
      if (!this._historic_CLIENT) this._historic_CLIENT = new IApiRestHistoricoCurriculumsClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._historic_CLIENT;
    }
  }, {
    key: "HistoricSolicitudes_CLIENT",
    get: function get() {
      if (!this._historicSolicitudes_CLIENT) this._historicSolicitudes_CLIENT = new IApiRestHistoricoFormsInternosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._historicSolicitudes_CLIENT;
    }
  }, {
    key: "GestionMenu_CLIENT",
    get: function get() {
      if (!this._gestionmenu_CLIENT) this._gestionmenu_CLIENT = new IApiRestGestionMenuClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._gestionmenu_CLIENT;
    }
  }, {
    key: "Documentacion_CLIENT",
    get: function get() {
      if (!this._documentacion_CLIENT) this._documentacion_CLIENT = new IApiRestDocumentacionClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._documentacion_CLIENT;
    }
  }, {
    key: "GestionTextos_CLIENT",
    get: function get() {
      if (!this._gestiontextos_CLIENT) this._gestiontextos_CLIENT = new IApiRestGestionTextosClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._gestiontextos_CLIENT;
    }
  }, {
    key: "Login_CLIENT",
    get: function get() {
      if (!this._user_CLIENT) this._user_CLIENT = new IApiRestLoginClient(this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      return this._user_CLIENT;
    }
  }, {
    key: "Datos_Client",
    get: function get() {
      var _this = this;
      return this.__get_client(this._datos_CLIENT, function () {
        return _this._datos_CLIENT = new IApiRestDatosClient(_this.AccesoServicios._proxyUrl(BASE_CANDIDATO_API));
      });
    }
  }, {
    key: "__get_client",
    value: function __get_client(client, setter) {
      if (!client) return setter();
      return client;
    }
  }]);
}();
angular.module('candidato').service('AccesoDatos', AccesoDatos);